function isEmptyResponse(props) {
  const hasError = !!(props?.fields?.error || props?.fields?.apiData?.error);
  if (hasError) {
    return false;
  }
  const data = props?.fields?.apiData;
  // if the component has hidden = true we do not have to show the component
  if (!data || Object.keys(data).length === 0) return false;
  if (!(data && data.constructor === Object && Object.keys(data).length === 0)) return !(data && 'hidden' in data && data.hidden);
  return false;
}

export { isEmptyResponse };
